import React, { useCallback, useMemo } from "react";
import { ApplicationFlowSteps } from "../../route/application/authenticated/application-flow/types";
import { BasicAccountApplicationDocument } from "../../api/commercial/generated-types";
import { CompanyOnlineMapper } from "./mapper";
import { CompanyOnlineModel } from "./types";
import { CompanyOnline } from "./index";
import BasicAccountApplicationAPI from "../../api/commercial/basic-account-application";

interface CompanyOnlineAdapterProps {
  basicAccountApplication: BasicAccountApplicationDocument;
  triggerReload: () => void;
  setStep: (step: ApplicationFlowSteps) => void;
}

export const CompanyOnlineAdapter: React.FC<CompanyOnlineAdapterProps> = ({
  basicAccountApplication,
  triggerReload,
  setStep,
}: CompanyOnlineAdapterProps): React.JSX.Element => {
  const companyOnlineModel = useMemo(() => {
    return CompanyOnlineMapper.mapDocumentToPageModel(basicAccountApplication);
  }, [basicAccountApplication]);

  const goBack = useCallback(() => {
    setStep(ApplicationFlowSteps.POWER_OF_ATTORNEY);
  }, [setStep]);

  const goNext = useCallback(
    async (companyOnlineModel: CompanyOnlineModel) => {
      await BasicAccountApplicationAPI.updateCompanyOnline(
        CompanyOnlineMapper.mapPageModelToRequest(
          companyOnlineModel,
          basicAccountApplication.applicationRef,
        ),
      );
      triggerReload();
    },
    [basicAccountApplication.applicationRef, triggerReload],
  );

  return (
    <CompanyOnline
      authorizedRepresentatives={companyOnlineModel.authorizedRepresentatives}
      companyName={companyOnlineModel.companyName}
      initialValues={companyOnlineModel}
      goBack={goBack}
      goNext={goNext}
    />
  );
};
